package com.yendo.mx.ui.components

import androidx.compose.foundation.background
import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardActions
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.filled.Close
import androidx.compose.material.icons.filled.Search
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.LocalFocusManager
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.input.TextFieldValue
import androidx.compose.ui.unit.dp
import com.yendo.mx.ui.theme.RosaYendo

@Composable
fun BuscadorYendo(
    valor: TextFieldValue, 
    alCambiar: (TextFieldValue) -> Unit, 
    focoAutomatico: Boolean = true,
    alBuscar: () -> Unit = {},
    onBack: () -> Unit = {} // 🚀 NUEVO: BOTÓN DE REGRESO AL HOME
) {
    val focusManager = LocalFocusManager.current
    val focusRequester = remember { FocusRequester() }

    LaunchedEffect(Unit) {
        if (focoAutomatico) {
            try {
                focusRequester.requestFocus()
            } catch (e: Exception) {
                // Ignorar si falla el foco en el primer frame
            }
        }
    }

    val isDark = isSystemInDarkTheme()
    val colorFondo = if (isDark) Color(0xFF1E1E1E) else Color.White
    val colorTexto = if (isDark) Color.White else Color.Black
    val colorSecundario = if (isDark) Color(0xFFAAAAAA) else Color.Gray

    Box(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = 16.dp, vertical = 8.dp)
            .shadow(
                elevation = if (isDark) 4.dp else 8.dp,
                shape = RoundedCornerShape(28.dp),
                spotColor = Color.Black.copy(alpha = if (isDark) 0.5f else 0.12f),
                ambientColor = Color.Black.copy(alpha = if (isDark) 0.2f else 0.05f)
            )
            .background(colorFondo, RoundedCornerShape(28.dp))
    ) {
        TextField(
            value = valor,
            onValueChange = alCambiar,
            modifier = Modifier
                .fillMaxWidth()
                .focusRequester(focusRequester),
            placeholder = { Text("¿Qué se te antoja hoy?", color = colorSecundario) },
            leadingIcon = {
                IconButton(onClick = onBack) {
                    Icon(
                        imageVector = Icons.AutoMirrored.Filled.ArrowBack, 
                        contentDescription = "Regresar", 
                        tint = colorTexto
                    )
                }
            },
            trailingIcon = { 
                IconButton(
                    onClick = {
                        if (valor.text.isNotEmpty()) {
                            alCambiar(TextFieldValue(""))
                        } else {
                            onBack()
                        }
                    }
                ) {
                    Icon(Icons.Default.Close, contentDescription = "Limpiar / Salir", tint = colorSecundario)
                }
            },
            singleLine = true,
            keyboardOptions = KeyboardOptions(imeAction = ImeAction.Search),
            keyboardActions = KeyboardActions(onSearch = { 
                alBuscar() // 🚀 DISPARAR ACCIÓN
                focusManager.clearFocus() 
            }),
            colors = TextFieldDefaults.colors(
                focusedContainerColor = Color.Transparent,
                unfocusedContainerColor = Color.Transparent,
                disabledContainerColor = Color.Transparent,
                focusedIndicatorColor = Color.Transparent,
                unfocusedIndicatorColor = Color.Transparent,
                focusedTextColor = colorTexto,
                unfocusedTextColor = colorTexto,
                cursorColor = RosaYendo
            )
        )
    }
}
